module.exports = __webpack_public_path__ + "media/banners/peaceful_morning-8239dcf4.png";